import {
  ADD_LANGUAGE,
  ANNOUNCEMENT_SELECT,
  DATA_REQUEST_ASYNC,
  LOCALE_DELETE_ASYNC,
  LOCALE_REQUEST_ASYNC,
} from './constants'

export const fetchData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })

export const fetchLocale = (data) => ({
  type: LOCALE_REQUEST_ASYNC.INITIATE,
  payload: { data },
})
export const fetchLocaleSuccess = (data) => ({
  type: LOCALE_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchLanguagesSuccess = (data) => ({
  type: LOCALE_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchLocaleError = (error) => ({
  type: LOCALE_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchLocaleCancel = () => ({ type: LOCALE_REQUEST_ASYNC.CANCEL })

export const deleteLocale = (data) => ({
  type: LOCALE_DELETE_ASYNC.INITIATE,
  payload: { data },
})
export const deleteLocaleSuccess = (data) => ({
  type: LOCALE_DELETE_ASYNC.SUCCESS,
  payload: { data },
})
export const deleteLocaleError = (error) => ({
  type: LOCALE_DELETE_ASYNC.ERROR,
  error,
})
export const deleteLocaleCancel = () => ({ type: LOCALE_DELETE_ASYNC.CANCEL })

export const selectAnnouncement = (itemIndex) => ({
  type: ANNOUNCEMENT_SELECT,
  payload: { itemIndex },
})
export const addLanguage = (id) => ({ type: ADD_LANGUAGE, payload: { id } })

export default {
  // to props
  fetchData,
  fetchDataCancel,
  fetchLocale,
  fetchLocaleCancel,
  deleteLocale,
  deleteLocaleCancel,
  selectAnnouncement,
  addLanguage,
}
